module.exports = __webpack_public_path__ + "img/tb1039-2-1974.prt.855950bb.jpg";